import api from "@/api";
export default {
    getWriteConfig(boardId: number): Promise<board.WriteConfig> {
        return api.get<board.WriteConfig>({
            url: `/api/boardapi/Board/writeConfig?boardId=${boardId}`,
        });
    },
    docViewerKeyRequest(payload: any) {
        return api.post({
            url: "/workflow/outinterface/api/commonrequest",
            //url: '/common/outinterface/api/request',
            data: payload,
        });
    },

    /** 2024-09-12 개선사항 적용하기 위해 사용되는 api 호출
     *  param 없음. 새 게시글이 등록 된 BoardId를 가져옴**/
    fetchNewArticleBoardId() {
        return api.get({
            url: "/api/BoardApi/Board/newArticleBoard",
        });
    },
};
